import {Component, ElementRef, EventEmitter, Inject, Output, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BaseModalComponent} from '../base-modal/base-modal.component';
import {ProgressService} from '../../../service/progress.service';
import {NotificationHandler} from '../../../helper/notification.handler';

export interface DeleteConfirmationData {
  title?: string;
  content?: string;
  archive?: boolean;
  action?: string;
  itemType?: string;
  name?: string;
  actionDesc?: string;
}

@Component({
  selector: 'delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.scss']
})
export class DeleteConfirmationModalComponent extends BaseModalComponent {

  title: string;
  content: string;
  archive: boolean;
  action: string;
  itemType: string;
  name: string | undefined;
  actionDesc: string | undefined;

  @Output() deleteConfirmed = new EventEmitter<DeleteContext>();

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  private readonly data: DeleteConfirmationData;

  constructor(dialogRef: MatDialogRef<DeleteConfirmationModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: DeleteConfirmationData) {
    super(dialogRef, progressService);

    this.title = data.title || $localize`:Confirm Modal|Confirm delete modal confirmation title@@confirm-delete-modal-confirmation-title:Delete Confirmation`;
    this.content = data.content || $localize`:Confirm Modal|Confirm delete modal confirmation prompt@@confirm-delete-modal-confirmation-prompt:Data will be removed from your account`;
    this.itemType = data.itemType || $localize`:Confirm Modal|Confirm delete item type title@@confirm-delete-item-type-title:Data`;
    this.archive = data.archive || false;
    this.action = this.archive
      ? $localize`:General|Archive action label@@general-archive-action-label:Archive`
      : $localize`:General|Delete action label@@general-delete-action-label:Delete`;
    this.name = data.name;
    this.actionDesc = data.actionDesc;

    this.data = data;
  }

  proceed(): void {
    this.startProgress();

    this.deleteConfirmed.emit({
      data: this.data,
      modal: this
    });
  }

  proceedAllowed(): boolean {
    return true;
  }

  public deleteHandled(error?: string, details?: unknown) {
    if (error) {
      NotificationHandler.handleError(error, details);
      this.stopProgress();
    } else {
      this.stopProgress();
      this.closeModal();

      if (this.archive) {
        NotificationHandler.notification(`${$localize`:Confirm Modal|Confirm archive confirmation notification@@confirm-archive-modal-confirmation-notification:${this.itemType} was archived successfully`}`);
      } else {
        NotificationHandler.notification(`${$localize`:Confirm Modal|Confirm delete confirmation notification@@confirm-delete-modal-confirmation-notification:${this.itemType} was deleted successfully`}`);
      }
    }
  }
}

export interface DeleteContext {

  data: any;

  modal: DeleteConfirmationModalComponent;

}
